<template>
    <div class="head-img">
        <img v-if="avatar" :src="avatar" alt="" :style="{'width': width + 'px', 'height': height + 'px', 'top': top + 'px'}" class="person-img mr5" :class="{'man-border': sex === 1, 'woman-border': sex === 2}">
        <svg class="iconSymbol mr5" aria-hidden="true" :style="{'fontSize': width + 'px', 'top': top + 'px'}" v-else>
			<use xlink:href="#iconmorentouxiang" />
		</svg>
        <i v-if="useModal" class="modal" :style="{'width': width + 'px', 'height': height + 'px', 'top': top + 'px'}"></i>
    </div>
</template>

<script>
export default {
    props: {
        avatar: {
            type: String,
            default: ''
        },
        width: {
            type: Number,
            default: 24
        },
        height: {
            type: Number,
            default: 24
        },
        sex: {
            type: Number,
            default: 0
        },
        top: {
            type: Number,
            default: 0
        },
        useModal: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.head-img {
    position: relative;
    display: inline-block;
    padding: 1px 0;
}
.person-img {
    vertical-align: bottom;
    position: relative;
}
.iconSymbol {
    position: relative;
}
.modal {
    position: absolute;
    left: 0;
    border-radius: 50%;
    background-color: rgba($color: #000000, $alpha: 0.2);
    opacity: 0;

    &:hover {
        opacity: 1;
    }
}
</style>